var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"system-pages-b406f87433efd56f77c82a71647d723231a18798"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/system-pages";

import env from '@y2/environments';

import { initSentry, OWNERS } from '../../sentry.config.base';

initSentry(env.name, 'system-pages', OWNERS.DEADPOOL);
